'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19.015 9.883a.344.344 0 0 1 .466 0l3.878 3.528a.348.348 0 0 1 .113.256l.002 6.904a.347.347 0 0 1-.346.347h-7.756a.347.347 0 0 1-.347-.347l-.001-6.904c0-.097.04-.19.113-.256Zm.233.724-3.532 3.213.002 6.405h.978v-2.818c0-.128.104-.23.23-.23h1.709a.23.23 0 0 1 .23.23v2.818h3.916l-.002-6.405-3.531-3.213Zm-.844 7.031h-1.246v2.587h1.246v-2.587Zm.614-9.501a.347.347 0 0 1 .458 0l1.528 1.345V9.34h.692v.75l.695.613V8.846h.693V8.5h-.693v.346h-1.58v-.692h2.47v.692h-.197v2.466l.573.504-.458.52-3.952-3.477-3.946 3.472-.458-.52Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21.525 17.176a.23.23 0 0 1 .23.231v1.708a.231.231 0 0 1-.23.231h-1.708a.23.23 0 0 1-.23-.231v-1.708a.23.23 0 0 1 .23-.231h1.708Zm-.231.462h-1.246v1.246h1.246v-1.246Zm.278-3.374a.23.23 0 0 1 .23.231v1.708a.23.23 0 0 1-.23.23h-1.708a.23.23 0 0 1-.231-.23v-1.708c0-.128.104-.231.23-.231h1.709Zm-2.892-.005a.23.23 0 0 1 .23.231v1.708a.231.231 0 0 1-.23.231h-1.708a.232.232 0 0 1-.231-.231V14.49c0-.128.104-.231.23-.231h1.709Zm2.66.467h-1.245v1.246h1.246v-1.246Zm-2.891-.005h-1.246v1.246h1.246v-1.246Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m10.391 9.834.06.044 3.879 3.528c.054.05.09.115.105.185l.008.071.002 6.904a.347.347 0 0 1-.28.34l-.067.007H6.343a.347.347 0 0 1-.34-.277l-.007-.07-.002-6.904c0-.072.023-.143.065-.201l.049-.055 3.878-3.528a.345.345 0 0 1 .405-.044Zm-8.969.044L5.3 13.406a.35.35 0 0 1 .114.257l.001 6.904a.348.348 0 0 1-.346.346H.735v-.693h3.988l-.002-6.404-3.532-3.213-.223.203-.466-.513.456-.415a.347.347 0 0 1 .466 0Zm8.797.724-3.532 3.213.002 6.405h.978v-2.818c0-.106.072-.196.17-.222l.06-.009h1.709a.23.23 0 0 1 .222.17l.009.061v2.818h3.915l-.002-6.405-3.531-3.213Zm-.844 7.031H8.129v2.587h1.246v-2.587Zm3.12-.462c.129 0 .232.104.232.231v1.708a.23.23 0 0 1-.231.231h-1.708a.231.231 0 0 1-.231-.231v-1.708c0-.127.104-.231.23-.231h1.709Zm-9.028 0c.127 0 .23.104.23.231v1.708a.231.231 0 0 1-.23.231H1.759a.231.231 0 0 1-.231-.231v-1.708c0-.127.104-.231.23-.231h1.709Zm8.798.462h-1.246v1.246h1.246v-1.246Zm-9.03 0H1.99v1.246h1.246v-1.246Zm9.308-3.374c.127 0 .23.103.23.231v1.708a.232.232 0 0 1-.23.231h-1.708a.231.231 0 0 1-.231-.231V14.49a.23.23 0 0 1 .23-.231h1.709Zm-9.03 0c.128 0 .232.103.232.231v1.708a.232.232 0 0 1-.231.231H1.806a.231.231 0 0 1-.231-.231V14.49a.23.23 0 0 1 .23-.231h1.709Zm6.138-.005a.23.23 0 0 1 .23.231v1.708a.231.231 0 0 1-.23.231H7.943a.232.232 0 0 1-.231-.231v-1.708c0-.128.104-.231.23-.231h1.709Zm2.66.467h-1.245v1.246h1.246v-1.246Zm-9.028 0H2.037v1.246h1.246v-1.246Zm6.137-.005H8.174v1.246H9.42v-1.246Zm1.028-6.584 4.18 3.679-.457.52-3.952-3.478-3.947 3.473-.457-.52L9.99 8.132a.347.347 0 0 1 .458 0Zm-9.03 0L5.6 11.81l-.458.52L1.19 8.853l-.228.2-.457-.52.456-.401a.347.347 0 0 1 .458 0Z",
    fill: "#87868F"
  })));
});
var FwSet0TownhouseCorner = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0TownhouseCorner = FwSet0TownhouseCorner;